import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function Skeleton({ lineHeight, fontSize, width, borderRadius }) {
    const isPadding = lineHeight && fontSize;
    return (
        <table
            className="skeleton"
            style={{
                width: `${width ? `${width}px` : '100%'}`,
                height: `${lineHeight}px`,
                paddingTop: `${isPadding ? '1px' : ''}`,
            }}
            border="0"
            cellPadding="0"
            cellSpacing="0"
        >
            <thead></thead>
            <tbody>
                <tr>
                    <td>
                        <span
                            style={{
                                height: `${fontSize || lineHeight}px`,
                                borderRadius: `${borderRadius ? `${borderRadius}px` : ''}`,
                            }}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

Skeleton.propTypes = {
    lineHeight: PropTypes.number,
    fontSize: PropTypes.number,
    width: PropTypes.number,
    borderRadius: PropTypes.number,
};

export default Skeleton;
export { Skeleton };



// WEBPACK FOOTER //
// ./src/components/skeleton/index.js